import { render, staticRenderFns } from "./improveSetting.vue?vue&type=template&id=2e189960&scoped=true&"
import script from "./improveSetting.vue?vue&type=script&lang=js&"
export * from "./improveSetting.vue?vue&type=script&lang=js&"
import style0 from "./improveSetting.vue?vue&type=style&index=0&id=2e189960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e189960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e189960')) {
      api.createRecord('2e189960', component.options)
    } else {
      api.reload('2e189960', component.options)
    }
    module.hot.accept("./improveSetting.vue?vue&type=template&id=2e189960&scoped=true&", function () {
      api.rerender('2e189960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/improveSetting.vue"
export default component.exports